var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.328 14.808H14.704C14.2622 14.808 13.904 15.1662 13.904 15.608C13.904 16.0498 14.2622 16.408 14.704 16.408H16.624C14.8187 18.2946 12.0484 18.8953 9.62382 17.9258C7.19929 16.9563 5.60683 14.6112 5.6 12C5.6 11.5582 5.24183 11.2 4.8 11.2C4.35817 11.2 4 11.5582 4 12C4.00864 15.193 5.91511 18.075 8.85019 19.3322C11.7853 20.5893 15.1868 19.9808 17.504 17.784V19.2C17.504 19.6418 17.8622 20 18.304 20C18.7458 20 19.104 19.6418 19.104 19.2V15.6C19.0999 15.1705 18.7573 14.8209 18.328 14.808ZM12 4C9.94911 4.00585 7.97879 4.79913 6.496 6.216V4.8C6.496 4.35817 6.13783 4 5.696 4C5.25417 4 4.896 4.35817 4.896 4.8V8.4C4.896 8.84183 5.25417 9.2 5.696 9.2H9.296C9.73783 9.2 10.096 8.84183 10.096 8.4C10.096 7.95817 9.73783 7.6 9.296 7.6H7.376C9.18027 5.71445 11.9487 5.11328 14.3725 6.08069C16.7963 7.0481 18.3899 9.39029 18.4 12C18.4 12.4418 18.7582 12.8 19.2 12.8C19.6418 12.8 20 12.4418 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default ForwardRef;